<template lang="pug">
.has-text-centered
  p 
    span Past 24hr profitability (
    b {{ selectedAlgorithm.name }}
    span  mining):

  br
  .field.has-addons
    .control.is-medium.is-expanded(:class="{'is-loading': isLoadingCalculator}")
      input.input.is-medium.hr_input(
        type='text', 
        :placeholder="selectedAlgorithm.name"
        @keyup.enter="calculateProfitability"
        v-model="calculatorValue"
        :disabled="isLoadingCalculator"
        v-on:input="debounceInput"
        ref="calculatorinput"
      )
    .control
      span.select.is-medium
        select(v-model="unitOfMeasurementSelected", @change="calculateProfitability")
          option(v-for="o in selectOptions", :value="o.code") {{ o.description }}
  br
  table.table-calculate
    tbody
      tr
        td
          span(v-if="calculatorPerDay") {{ calculatorValue }} {{ unitOfMeasurementSelected.toUpperCase()  }}{{ selectedAlgorithm.minimumUnitOfMeasurement }}/s
          span(v-else) - {{ unitOfMeasurementSelected.toUpperCase()  }}{{ selectedAlgorithm.minimumUnitOfMeasurement }}/s
        td
          span =
        td
          span.day_result(v-if="calculatorPerDay") {{ calculatorPerDay }}
          span.day_result(v-else) - 
        td {{ coin }} / day
      tr
        td
        td
        td
          span.month_result(v-if="calculatorPerDay") {{ calculatorPerMonth }}
          span.month_result(v-else) - 
        td {{ coin }} / month
  br
  p.fs-12.mw-300.m-auto.mt-5.fw-400.has-text-centered
    span Note that results  
    a(href='https://unmineable.com/support/article/why-is-there-a-difference-between-my-results-and-the-calculator/') may vary
    span . The calculator is based on the pool's past 24hr performance.
</template>

<script>
import { apiPost, debounce } from '../util/general'
export default {
  name: 'c_calculator',
  props: ['selectedAlgorithm', 'coin'],
  data () {
    return {
      calculatorValue             : '',
      calculatorPerDay            : '',
      calculatorPerMonth          : '',
      isLoadingCalculator         : false,
      selectOptions               : [],
      unitOfMeasurementSelected   : '',
      units: [
        '', 'k', 'm', 'g', 't', 'p', 'e', 'z'
      ]
    }
  },
  mounted () {
    let vm = this
    vm.populateUnits()
  },
  methods: {
    debounceInput: debounce(function (e) {
      this.calculateProfitability()
    }, 500),
    calculateProfitability () {
      let vm = this

      if (+vm.calculatorValue  > 0) {
        vm.isLoadingCalculator = true

        let normalizedHr = vm.getNormalizedHr()

        var url = '/v3/calculate/reward'
        var obj = {
          mh: +normalizedHr,
          algo: vm.selectedAlgorithm.code,
          coin: vm.coin
        }
        apiPost(vm, url, obj, function (data) {
          vm.calculatorPerDay   = data.per_day
          vm.calculatorPerMonth = data.per_month
        }, function (err) {
          console.error('Error:', err.message)
          vm.$store.dispatch('notifyError')
        }, function () {
          vm.isLoadingCalculator = false
          vm.$nextTick(() => {
            vm.$refs.calculatorinput.focus()
          })
        })
      } else {
        vm.calculatorPerDay   = 0
        vm.calculatorPerMonth = 0
      }
    },
    populateUnits () {
      let vm = this

      vm.selectOptions = []

      let startPopulating = false

      for (var i = 0; i < vm.units.length; i++) {
        if (vm.selectedAlgorithm.minCalculatorUnit === vm.units[i]) startPopulating = true

        if (startPopulating) {
          vm.selectOptions.push({
            code: vm.units[i],
            description : vm.units[i].toUpperCase() + vm.selectedAlgorithm.minimumUnitOfMeasurement + '/s'
          })
        }

        if (vm.selectedAlgorithm.maxCalculatorUnit === vm.units[i]) break
      }

      vm.unitOfMeasurementSelected = vm.selectedAlgorithm.defaultCalculatorUnit || vm.selectedAlgorithm.preUnitOfMeasurement
    },
    getNormalizedHr () {
      let vm = this
      let value = +vm.calculatorValue
      let calculatorUnit = vm.selectedAlgorithm.preUnitOfMeasurement
      let selectUnit = vm.unitOfMeasurementSelected

      // Transform to its minimum unit
      let selectUnitIndex = vm.units.indexOf(selectUnit)
      value = value * (1000 ** selectUnitIndex)

      // Now transform into calculator unit
      let calculatorUnitIndex = vm.units.indexOf(calculatorUnit)
      value = value / (1000 ** calculatorUnitIndex)

      return value
    }
  }
}
</script>

<style lang="stylus" scoped>
.field
  padding 0px 20px
.table-calculate
  font-weight: 400;
  display: inline-block;
  font-size 13px
  td
    padding 0px 5px

.navbar-link:not(.is-arrowless)::after, .select:not(.is-multiple):not(.is-loading)::after
  border: 2px solid #000
  border-right: 0;
  border-top: 0;
  height: 0.4em;
  width: 0.4em;
  margin-top: -0.24em;
  border-radius 0px

.select select:not([multiple]) 
  padding-right: 2em;

</style>



// WEBPACK FOOTER //
// c_calculator.vue?9dd04910